import Headroom from 'headroom.js'

const stickyHeader = () => {
    var siteHeader = document.querySelector('.siteHeader')
    var servicesPage = document.querySelector('body.services-page')
    var careersPage = document.querySelector('body.careers-page')
    const mq = window.matchMedia('(min-width: 1000px)')

    if (siteHeader) {
        if ((servicesPage || careersPage) && mq.matches) {
            var headroom = new Headroom(siteHeader, {
                classes: {
                    initial: '-headroom -absolute'
                },
            })
        } else {
            var headroom = new Headroom(siteHeader, {
                offset: {
                    up: 50,
                    down: 5
                },
                tolerance: 0,
                classes: {
                    initial: '-headroom',
                    pinned: '-pinned',
                    unpinned: '-unpinned',
                    top: '-top',
                    notTop: '-notTop'
                },
            })
        }

        headroom.init()
    }
}

export default stickyHeader